import React from 'react';
import PropTypes from 'prop-types';
import ioLogo from './io icons/Logo.svg';
import ioFab from './io icons/fab icon.svg';
import ioNewChat from './io icons/new chat.svg';
import ioMore from './io icons/more.svg';
import ioMinimise from './io icons/minimise.svg';
import ioClose from './io icons/close.svg';
import ioEdit from './io icons/edit.svg';
import ioCopy from './io icons/copy.svg';
import ioLike from './io icons/like.svg';
import ioDislike from './io icons/dislike.svg';
import ioMic from './io icons/Mic.svg';
import ioSendActive from './io icons/send-button-v.svg';
import ioSendIdle from './io icons/send-button_g.svg';

export const IO_ICONS = {
	logo: ioLogo,
	fab: ioFab,
	newChat: ioNewChat,
	more: ioMore,
	minimise: ioMinimise,
	close: ioClose,
	edit: ioEdit,
	copy: ioCopy,
	like: ioLike,
	dislike: ioDislike,
	mic: ioMic,
	sendActive: ioSendActive,
	sendIdle: ioSendIdle,
};

/**
 * Renders an io Genie SVG as a sized image so clip-path ids stay unique
 * when the same icon appears more than once.
 *
 * @param {Object} props
 * @param {string} props.src imported SVG url
 * @param {number} [props.size]
 * @param {string} [props.className]
 * @param {string} [props.alt]
 * @return {JSX.Element}
 */
export function IoIcon({ src, size = 18, className = '', alt = '' }) {
	return (
		<img
			src={src}
			alt={alt}
			className={`ai-chat-panel__io-icon${className ? ` ${className}` : ''}`}
			width={size}
			height={size}
			draggable={false}
			aria-hidden={alt ? undefined : true}
		/>
	);
}

IoIcon.propTypes = {
	src: PropTypes.string.isRequired,
	size: PropTypes.number,
	className: PropTypes.string,
	alt: PropTypes.string,
};
